module.exports = __webpack_public_path__ + "static/media/corporate-services-img38.f8d615c0.jpg";